export const routes = (prefix) => [
    {
        path: `/${prefix}/imaging`,
        name: `${prefix}.imaging.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.imaging.index`,
                PageDescription: "Imaging Listing/Create",
            },
        },
    },
]; 
